import { useState, useCallback } from "react";

const useApiLogs = (maxEntries = 50) => {
  const [logs, setLogs] = useState([]);

  const addLog = useCallback((type, text, details = null) => {
    const newLog = {
      id: Date.now() + Math.random(),
      timestamp: new Date().toLocaleTimeString("pt-BR"),
      type,
      text,
      details
    };
    setLogs(prev => [newLog, ...prev].slice(0, maxEntries));
  }, [maxEntries]);

  const clearLogs = useCallback(() => {
    setLogs([]);
  }, []);

  return { logs, addLog, clearLogs };
};

export default useApiLogs;
